<!-- 用户手机号验证码登录 -->
<template>
  <div class="login-container">
    <van-image round width="60px" height="60px" src="https://files.souji168.cn/uploads/20241231/f57ebce8a72b823912904fe76eda0909.png" class="avatar" />
    <div class="title">欢迎使用搜机网</div>
    <div class="login-form">
      <van-cell-group class="cell-group">
        <van-field v-model="phone" name="phone" label="手机号" placeholder="请输入手机号" :rules="[{ required: true, message: '请输入手机号' }]" clearable />
        <van-field v-model="code" name="code" label="验证码" placeholder="请输入验证码" :rules="[{ required: true, message: '请输入验证码' }]" clearable>
          <template #button>
            <van-button size="small" type="info" :disabled="countdown > 0" loading-text="发送中..." :loading="sendLoading" @click="sendCode">  {{ countdown > 0 ? `${countdown}秒后重发` : '获取验证码' }}
            </van-button>
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group class="cell-group">
        <van-cell title="邀请人" :value="inviteUserInfo.nickname || '-'" />
      </van-cell-group>
      <van-button type="info" block class="login-btn" :disabled="!phone || !code" loading-text="登 录 中..." :loading="loading" @click="onSubmit">登 录</van-button>

      <!-- Dashboard Stats Section -->
      <div class="dashboard-stats">
        <div class="stats-banner">
          <span class="banner-text">近30天<span class="num-highlight">{{ stats.recent30DaysPositiveRate }}</span>好评!今日发布货源信息:<span class="num-highlight">{{ stats.todayPublishCount }}</span>条</span>
        </div>
        <div class="merchant-list">
          <div class="list-wrapper" :style="{ transform: `translateY(${scrollY}px)` }">
            <div
              v-for="(item, index) in doubleList"
              :key="index"
              class="merchant-item">
              <div class="merchant-info">
                <img
                  :src="item.avatar || defaultAvatar"
                  class="merchant-avatar"
                  alt=""
                  @error="onAvatarError($event)">
                <div class="merchant-details">
                  <div class="merchant-name-phone">
                    <span class="merchant-name">{{ item.nickname || item.maskedPhone }}</span>
                    <span class="merchant-phone">{{ item.maskedPhone }}</span>
                  </div>
                  <div class="merchant-meta">
                    <span class="register-time">{{ item.registerTime }}</span>
                    <span :class="['certify-status', item.certifyStatus === '已认证' ? 'certified' : 'uncertified']">
                      {{ item.certifyStatus === '已认证' ? '已入驻' : item.certifyStatus }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="stats-footer">
          <span class="footer-text">7大模块119个功能，快一步体验，赢<span class="cash-highlight">¥600</span>现金奖励</span>
        </div>
      </div>
    </div>
    <!-- <van-overlay :show="loading">
      <van-loading color="#1989fa" style="text-align: center;" />
    </van-overlay> -->

  </div>
</template>
<script>
import { Toast } from 'vant'
import { getInviteLaunchUserInfo, loginMsg } from '@/api/h5'
import { sendMsgCode } from '@/api/login'
import request from '@/common/request.js'
export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      sendLoading: false,
      phone: '',
      code: '',
      countdown: 0,
      timer: null,
      inviteUserInfo: {},
      inviteToken: '',
      regFrom: 'invite',
      stats: {
        recent30DaysPositiveRate: '100%',
        todayPublishCount: 0
      },
      merchantList: [],
      displayList: [],
      scrollIndex: 0,
      scrollTimer: null,
      refetchTimer: null,
      scrollY: 0,
      itemHeight: 38,
      animFrame: null,
      defaultAvatar: 'https://files.souji168.cn/uploads/20241231/f57ebce8a72b823912904fe76eda0909.png'
    }
  },
  computed: {
    isValidPhone () {
      const phoneRegex = /^1[3-9]\d{9}$/
      return phoneRegex.test(this.phone)
    },
    isValidCode () {
      return this.code.length > 3
    },
    scrollData () {
      if (this.merchantList.length <= 5) return this.merchantList
      return this.merchantList.slice(0, 5)
    },
    doubleList () {
      if (this.scrollData.length <= 3 && this.merchantList.length <= 3) return this.scrollData
      return [...this.scrollData, ...this.scrollData]
    }
  },
  mounted () {
    // 获取url中path参数
    // console.log('this.$route.params.id', this.$route.params.id)
    this.inviteToken = this.$route.params.inviteToken
    this.getInviteLaunchUserInfo(this.inviteToken)

    // 获取URL查询参数from
    if (this.$route.query.from) {
      this.regFrom = this.$route.query.from
    }

    this.fetchDashboardStats()
    this.startRefetch()
  },
  beforeDestroy () {
    this.stopScroll()
    this.stopRefetch()
  },
  methods: {
    async getInviteLaunchUserInfo (inviteToken) {
      if (!inviteToken) {
        console.log('没有邀请token')
        return
      }
      const params = {
        inviteToken: inviteToken
      }
      try {
        const { code, data } = await getInviteLaunchUserInfo(params)
        console.log('获取邀请人信息', code, data)
        if (code === 1 && data.username) {
          this.inviteUserInfo = data
        } else {
          console.error('没有邀请人')
          this.$router.replace({ path: '/' })
        }
      } catch (error) {
        console.error('获取邀请人信息失败:', error)
      }
    },
    sendCode () {
      if (!this.isValidPhone) {
        Toast.fail('请输入有效的手机号')
        return false
      }

      // 发送验证码请求
      this.getCode()
    },
    startCountdown () {
      this.countdown = 60
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.timer)
          this.timer = null
          this.countdown = 0
        }
      }, 1000)
    },
    // 获取验证码
    async getCode () {
      try {
        this.sendLoading = true
        const params = {
          phoneNumber: this.phone,
          eventName: 'REGISTER'
        }
        const { code } = await sendMsgCode(params)
        if (code === 1) {
          Toast.success('验证码已发送')
          this.sendLoading = false
          this.startCountdown()
        } else {
          Toast.fail('获取验证码失败，请稍后重试')
        }
      } catch (err) {
        console.log('获取验证码失败', err)
      } finally {
        this.sendLoading = false
      }
    },
    // 提交登录
    async onSubmit () {
      if (!this.isValidPhone) {
        Toast.fail('请输入有效的手机号')
        return false
      }
      if (!this.isValidCode) {
        Toast.fail('请输入验证码')
        return false
      }
      // 提交登录请求
      // Toast.success('登录成功')
      const params = {
        username: this.phone,
        code: this.code,
        inviteToken: this.inviteToken,
        regFrom: this.regFrom
      }
      this.loading = true
      this.$store
        .dispatch('user/login', params)
        .then(() => {
          this.loading = false
          this.$router.push({ path: '/guide/index' })
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },

    // Fetch dashboard stats
    async fetchDashboardStats () {
      try {
        const res = await request.get('/anonymous/auth/dashboard/stats')
        if (res.code === 1 && res.data) {
          this.stats.recent30DaysPositiveRate = res.data.recent30DaysPositiveRate || '100%'
          this.stats.todayPublishCount = res.data.todayPublishCount || 0
          this.merchantList = res.data.newMerchants || []
          if (this.merchantList.length > 0) {
            this.initScroll()
          }
        }
      } catch (e) {
        console.error('获取仪表盘数据失败', e)
      }
    },

    initScroll () {
      this.startScroll()
    },

    startScroll () {
      this.stopScroll()
      const totalHeight = this.scrollData.length * this.itemHeight
      const speed = totalHeight / 8000 // pixels per ms, full cycle in 8s
      let lastTime = 0

      const animate = (time) => {
        if (!lastTime) lastTime = time
        this.scrollY -= (time - lastTime) * speed
        // Reset when scrolled past one set
        if (Math.abs(this.scrollY) >= totalHeight) {
          this.scrollY += totalHeight
        }
        lastTime = time
        this.animFrame = requestAnimationFrame(animate)
      }
      this.animFrame = requestAnimationFrame(animate)
    },

    stopScroll () {
      if (this.animFrame) {
        cancelAnimationFrame(this.animFrame)
        this.animFrame = null
      }
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },

    startRefetch () {
      this.stopRefetch()
      this.refetchTimer = setInterval(() => {
        this.fetchDashboardStats()
      }, 30000)
    },

    stopRefetch () {
      if (this.refetchTimer) {
        clearInterval(this.refetchTimer)
        this.refetchTimer = null
      }
    },

    onAvatarError (e) {
      e.target.src = this.defaultAvatar
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container{
  position: relative;
  padding: 0 15px;
  box-sizing: border-box;
  overflow-x: hidden;
  width: 100%;
  .title{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin-top: 6px;
  }
  .avatar{
    margin: 0 auto;
    margin-top: 10px;
    display: flex;
  }
  .cell-group{
    margin-top: 12px;
  }

  .login-btn{
    margin: 6px 0;
  }
}

.dashboard-stats {
  margin: 12px 0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.stats-banner {
  background: #fff;
  padding: 0px 8px;
  text-align: center;
}

.banner-text {
  color: #333;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.num-highlight {
  font-size: 15px;
  font-weight: 700;
  color: #ff4d4f;
}

.merchant-list {
  padding: 8px 16px;
  overflow: hidden;
  position: relative;
  height: 190px;
}

.list-wrapper {
  will-change: transform;
}

.merchant-item {
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.merchant-item:last-child {
  border-bottom: none;
}

.merchant-info {
  display: flex;
  align-items: center;
}

.merchant-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
  flex-shrink: 0;
}

.merchant-details {
  flex: 1;
  min-width: 0;
}

.merchant-name-phone {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
}

.merchant-name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 120px;
}

.merchant-phone {
  font-size: 12px;
  color: #999;
  flex-shrink: 0;
  margin-left: 8px;
}

.merchant-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.register-time {
  font-size: 12px;
  color: #999;
}

.certify-status {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 3px;
}

.certify-status.certified {
  color: #ffd700;
  background: #ff4d4f;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
}

.certify-status.uncertified {
  color: #999;
  background: #f5f5f5;
}

.stats-footer {
  background: #fff;
  padding: 0px 8px;
  text-align: center;
}

.footer-text {
  color: #3b82f6;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cash-highlight {
  font-size: 16px;
  font-weight: 700;
  color: #ff4d4f;
}
</style>
